export default "__VITE_ASSET__BoxT4cUQ__"